<template>
<div class="library-logo"  @click="returnToBaseLibrary()">
    <img :src="logoURL" alt="logo" class="logo">
</div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'logo-component',
  computed: {
    ...mapState({
      logoURL: state => state.base.library?.logo_url,
      librarySlug: state => state.base.library?.slug
    })
  },
  methods: {
    returnToBaseLibrary () {
      if (!localStorage.getItem('jwt')) {
        return
      }
      if (this.$route.query.filters || this.$route.query.searchText) {
        this.$store.dispatch('resetFilterAndSearch').then(() => {
          this.$router.push({ name: 'baseLibrary', query: { searchText: this.$route.searchText, filters: null } })
        })
      } else {
        this.$router.push({ name: 'baseLibrary' })
      }
    }
  }
}
</script>

<style scoped>

</style>
